export default __webpack_public_path__ + "src/assets/images/powerstrip/powerstrip_EU.png?b6c61ef9";